/**
 * Same-origin API under `/api` when embedded in driveops-backend (Kutioo-style).
 * Override with `VITE_API_URL` for a remote host (include `/api` if used).
 */
const configured = import.meta.env.VITE_API_URL

function normalizeApiBase(raw: string | undefined): string {
  if (raw == null || String(raw).trim() === '') return '/api/'
  const s = String(raw).trim()
  return s.endsWith('/') ? s : `${s}/`
}

export const API_ENDPOINT = normalizeApiBase(configured)

export const UPLOADS_PATH = (() => {
  if (API_ENDPOINT === '/api/') return '/uploads'
  try {
    const u = new URL(API_ENDPOINT, typeof window !== 'undefined' ? window.location.origin : 'http://localhost')
    return `${u.origin}/uploads`
  } catch {
    return '/uploads'
  }
})()

export const GOOGLE_MAPS_KEY =
  import.meta.env.VITE_GOOGLE_MAPS_KEY ?? 'AIzaSyDzB69I7EbPRZmbe8V0SRCrxzudTWDbMSQ'

export function getSocketOrigin(): string {
  const raw = configured != null ? String(configured).trim() : ''
  if (!raw || raw.startsWith('/')) {
    return typeof window !== 'undefined' ? window.location.origin : ''
  }
  try {
    const u = new URL(raw.includes('://') ? raw : `https://${raw}`)
    return `${u.protocol}//${u.host}`
  } catch {
    return raw.replace(/\/$/, '').replace(/\/api\/?$/i, '')
  }
}
